var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("v-data-table", {
    staticClass: "elevation-0",
    attrs: {
      "footer-props": _vm.footer,
      headers: _vm.headers,
      items: _vm.items,
      loading: _vm.loading,
      "multi-sort": false,
      options: _vm.options,
      "server-items-length": _vm.totalItems,
      "item-key": "id",
    },
    on: {
      "update:items": function ($event) {
        _vm.items = $event
      },
      "update:options": function ($event) {
        _vm.options = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "item.created_at",
        fn: function (_ref) {
          var item = _ref.item
          return [
            item.created_at
              ? _c(
                  "span",
                  {
                    staticClass: "d-block",
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm
                          .$moment(item.created_at)
                          .format("YYYY-MM-DD HH:mm:ss")
                      )
                    ),
                  ]
                )
              : _vm._e(),
          ]
        },
      },
      {
        key: "item.amount",
        fn: function (_ref2) {
          var item = _ref2.item
          return [
            _c("span", [
              _vm._v(
                _vm._s(
                  Number(item.amount).toLocaleString("en-US", {
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2,
                  })
                )
              ),
            ]),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }